import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { BaseApiService } from "@app/shared/services/base-api.service";

import { UserDto } from "@shared/models";

@Injectable({
  providedIn: "root",
})
export class UsersApiService extends BaseApiService {
  protected readonly endpoint = "/users";
  protected readonly microservice = "userManagement" as const;

  /**
   * GET /api/users
   */
  getAllUsers(): Observable<UserDto[]> {
    return this.get<UserDto[]>("");
  }
}
